const styles = () => ({
  enrichment: {
    display: 'flex',
    padding: 40,
    marginRight: 10,
  },

  person: {
    width: '50%',
  },

  company: {
    width: '50%',
  },

  traitsTable: {
    borderTop: '1px solid #F6F7F9',
    backgroundColor: `#FAFBFC`,
    paddingTop: 30,
    flex: '1 1 auto',
  },

  companyLoading: {
    width: '100%',
    height: 'auto',
    marginLeft: 10,
  },
});

export default styles;
